module.exports = function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "echo-worker.worker.8fcab5b615ae02c67c92.js");
}
